module.exports = __webpack_public_path__ + "static/media/FuelDark.ba12d856.svg";